<template>
  <div>
    <user-transaction-form
      transaction-type="deduct"
      :is-side-bar-active.sync="isSideBarActive"
      is-pending-transaction
      @refetch-user-wallet="$emit('refetch-user-wallet')"
    />
    <b-overlay
      variant="white"
      spinner-variant="primary"
      blur="0"
      opacity="0.75"
      rounded="sm"
      :show="loadingPendingTransactions"
    >
      <b-card>
        <b-card-title>
          Pending Transactions History
        </b-card-title>
        <b-row>
          <b-col
            md="12"
            class="d-flex justify-content-end align-items-center"
          >
            <b-button
              v-if="$can('write', 'user-wallet-transactions')"
              variant="success"
              class="mr-2"
              @click="isSideBarActive = true"
            >
              Add Pending Transaction
            </b-button>
          </b-col>
        </b-row>
        <b-table
          responsive
          :items="tableData"
          :fields="tableColumns"
          show-empty
          empty-text="No pending transactions found"
          class="mt-2"
        >
          <template #cell(created_at)="data">
            {{ `${data.item.created_at}Z` | formatDate }}
          </template>
          <template #cell(remark_text)="data">
            <component
              :is="data.item.service == 'trips' ? 'b-link': 'div' "
              :to="{ path: `/trips/${data.item.external_reference_id}` }"
              :class="data.item.service == 'trips' ? 'linkStyle' : ''"
            >
              {{ data.item.remark_text }}
            </component>
          </template>
          <template #cell(paid)="data">
            {{ data.item.paid? 'Yes' : 'No' }}
          </template>
          <template #cell(waive)="data">
            {{ data.item.waive? 'Yes' : 'No' }}
          </template>
          <template #cell(action)="data">
            <b-dropdown
              v-if="canWaive(data.item)"
              variant="link"
            >

              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>
              <b-dropdown-item @click="waivePendingTransaction('waive_with_comp', data.item.id)">
                <feather-icon icon="FileTextIcon" />
                <span class="align-middle ml-50">Waive with compensation</span>
              </b-dropdown-item>

              <b-dropdown-item @click="waivePendingTransaction('waive_without_comp', data.item.id)">
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">Waive without compensation</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>

        </b-table>
        <base-pagination
          v-model="queryParams.page"
          :total="total"
          @new-per-page="queryParams.size = $event"
        />
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  reactive, watch, toRef, computed, ref, onUnmounted,
} from '@vue/composition-api'
import {
  BOverlay, BCard, BCardTitle, BTable, BRow, BCol, BButton, BLink, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import BasePagination from '@/UI/BasePagination.vue'
import UserTransactionForm from './UserTransactionForm.vue'
import { errorNotification } from '@/utils/toast-notifications'

export default {
  components: {
    BOverlay,
    BCard,
    BCardTitle,
    BTable,
    BRow,
    BCol,
    BButton,
    UserTransactionForm,
    BasePagination,
    BLink,
    BDropdown,
    BDropdownItem,
  },
  props: {
    loadingPendingTransactions: {
      type: Boolean,
      default: false,
    },
    pendingTransactionsData: {
      type: Object,
      default: () => {},
    },
  },
  setup(props, ctx) {
    const isSideBarActive = ref(false)
    const tableColumns = [
      { key: 'created_at', label: 'Date/Time' },
      { key: 'transaction_type_label', label: 'Account Name' },
      { key: 'credit_amount', label: 'Credit' },
      { key: 'debit_amount', label: 'Debit' },
      { key: 'added_by', label: 'Added By' },
      { key: 'remark_text', label: 'Remark' },
      { key: 'paid', label: 'Paid' },
      { key: 'waive', label: 'Waive' },
      { key: 'action', label: 'Action' },
    ]
    const queryParams = reactive({
      page: 1,
      size: 10,
    })
    const total = ref(0)

    onUnmounted(() => {
      ctx.root.$store.commit('users/SET_USER_PENDING_TRANSACTIONS', null)
    })
    const canWaive = row => (row.debit_amount !== 0 && !row.paid && !row.waive)
    const tableData = computed(() => {
      if (props.pendingTransactionsData) {
        total.value = props.pendingTransactionsData.total
      }
      return props.pendingTransactionsData?.pending_transactions
    })

    watch([toRef(queryParams, 'page'), toRef(queryParams, 'size')], () => {
      ctx.emit('refetch-user-pending-transactions', queryParams)
    })
    const waivePendingTransaction = async (type, pendingTransactionId) => {
      try {
        if (props.pendingTransactionsData) {
          await ctx.root.$store.dispatch('billing/waivePendingTransactions', {
            waive: true,
            waive_type: type,
            id: pendingTransactionId,
          })
        }
        ctx.emit('refetch-user-wallet')
      } catch (error) {
        const errorCode = error?.response?.data?.statusCode
        if (errorCode === 422) {
          const errMessage = error.response.data.error.detail.message
          errorNotification(errMessage)
        } else {
          errorNotification('Something went wrong')
        }
      }
    }
    return {
      canWaive,
      isSideBarActive,
      tableColumns,
      queryParams,
      tableData,
      total,
      waivePendingTransaction,
    }
  },
}
</script>

<style scoped>

.linkStyle {
  color: blue;
}
</style>
